import React from 'react'
import cx from 'classnames'

import { PlayIcon } from '@wf-sl/common-icons'
import { Button } from '@wf-common/atoms'
import { Tooltip } from '../tooltip'
import { DIRECTIONS } from './constants'
import { spinnerButtonPropTypes as propTypes, spinnerButtonDefaultProps as defaultProps } from './types'

import styles from './spinner-button.module.css'

const iconProps = {
    [DIRECTIONS.left]: {
        className: cx(styles['svg-icon-left'], 't3sel-navigation-button-left'),
        rotateDegrees: 180
    },
    [DIRECTIONS.right]: {
        className: cx(styles['svg-icon-right'], 't3sel-navigation-button-right')
    }
}

export function SpinnerButton({ className, direction, disabled, onClick, tooltipText }) {
    const withTooltip = Boolean(tooltipText)
    const isLeftDirection = DIRECTIONS.left === direction
    const composedClassname = cx(
        className,
        { [styles['left-button']]: isLeftDirection },
        isLeftDirection ? 't3sel-spinner-button-left' : 't3sel-spinner-button-right'
    )

    const button = (
        <Button icon className={composedClassname} disabled={disabled} onClick={onClick}>
            <PlayIcon {...iconProps[direction]} />
        </Button>
    )

    if (withTooltip) {
        return (
            <Tooltip content={<span>{tooltipText}</span>} triggerOnHover>
                {button}
            </Tooltip>
        )
    }

    return button
}

SpinnerButton.propTypes = propTypes
SpinnerButton.defaultProps = defaultProps
